const DATE_FORMATTER = new Intl.DateTimeFormat("en-GB", { dateStyle: "long" })
const JUDGEMENT_CREDIT_FORMATTER = new Intl.NumberFormat("en-GB", {
  notation: "compact",
  maximumFractionDigits: 2,
})

export function formatBillingDate(value) {
  if (!value) return null

  return DATE_FORMATTER.format(new Date(value))
}

export function formatBillingPrice({ amount_pence: amountPence, currency }) {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amountPence / 100)
}

export function formatJudgementCredits(value) {
  return JUDGEMENT_CREDIT_FORMATTER
    .format(value)
    .replace(/[km]$/, (suffix) => suffix.toUpperCase())
}
